import { useCallback } from 'react';
import { useIMask } from 'react-imask';
import {
  FormControl,
  FormHelperText,
  FormLabel,
  OutlinedInput,
  type OutlinedInputProps,
} from '@mui/material';
import { withControl } from '@features/effector-form/hoc/withControl';

export const PhoneControl = withControl<OutlinedInputProps>(
  ({
    value,
    setValue,
    error,
    label,
    required,
    readOnly,
    disabled,
    isError,
    placeholder,
  }) => {
    const handleAccept = useCallback(
      (newValue: string) => {
        if (newValue !== value) {
          setValue(newValue);
        }
      },
      [value]
    );

    const handleComplete = useCallback(
      (newValue: string) => {
        setValue(newValue);
      },
      [value]
    );

    const { ref } = useIMask(
      { mask: '+{7}0000000000' },
      {
        onAccept: handleAccept,
        onComplete: handleComplete,
      }
    );

    return (
      <FormControl required={required} disabled={disabled}>
        {label && <FormLabel error={isError}>{label}</FormLabel>}
        <OutlinedInput
          inputRef={ref}
          value={value}
          readOnly={readOnly}
          disabled={disabled}
          placeholder={readOnly ? placeholder : '+7 000 000 00 00'}
          error={isError}
        />
        {Boolean(error?.trim().length) && <FormHelperText error>{error}</FormHelperText>}
      </FormControl>
    );
  }
);
